import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/product-pricing-tiers';

const productPricingTiersService = {
  /**
   * @param {string} productId
   * @param {string} pricingGroupId
   * @returns {Promise<{ tiers: Array, tiersQtyValid: boolean, tiersQtyError: string | null }>}
   */
  async list(productId, pricingGroupId) {
    const response = await apiClient.get(BASE, {
      params: { productId, pricingGroupId },
    });
    const body = response?.data;
    if (body?.success === false) {
      throw new Error(typeof body?.message === 'string' ? body.message : 'Failed to load tiers');
    }
    const d = body?.data ?? {};
    const list = d.tiers;
    return {
      tiers: Array.isArray(list) ? list : [],
      tiersQtyValid: d.tiersQtyValid !== false,
      tiersQtyError: typeof d.tiersQtyError === 'string' ? d.tiersQtyError : null,
    };
  },

  async get(uuid) {
    const response = await apiClient.get(`${BASE}/${uuid}`);
    const body = response?.data;
    if (body?.success === false) {
      throw new Error(typeof body?.message === 'string' ? body.message : 'Failed to load tier');
    }
    return body?.data?.tier ?? null;
  },

  async create(payload) {
    const response = await apiClient.post(BASE, payload);
    return response?.data;
  },

  async update(uuid, payload) {
    const response = await apiClient.patch(`${BASE}/${uuid}`, payload);
    return response?.data;
  },

  async remove(uuid) {
    const response = await apiClient.delete(`${BASE}/${uuid}`);
    return response?.data;
  },

  /**
   * @param {{ product_id: string, pricing_group_id: string }} payload
   */
  async syncFromSlabs(payload) {
    const response = await apiClient.post(`${BASE}/sync-from-slabs`, payload);
    return response?.data;
  },
};

export default productPricingTiersService;
